import { render, staticRenderFns } from "./mc-tally.vue?vue&type=template&id=33607f2b&scoped=true"
import script from "./mc-tally.vue?vue&type=script&lang=ts"
export * from "./mc-tally.vue?vue&type=script&lang=ts"
import style0 from "./mc-tally.vue?vue&type=style&index=0&id=33607f2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33607f2b",
  null
  
)

export default component.exports